import React from 'react';
import { useLanguage } from '../../Contexts/LanguageContext';
import './Timeline.scss';


const Timeline = () => {
  const { getLanguageData } = useLanguage();
  const data = getLanguageData();

  const sectionTitle = data.purposeSection.timelineHeading;
  const timelineItems = data?.purposeSection?.timelineItems || [];

  return (
    <>      
      <div className="timeline-container">
          <h3>{sectionTitle}</h3>
          <div className="timline">
            <img 
              src='/Assets/images/timeline-image-vascor.png' alt=""
            />            
          </div>
          {/* <div className='custom-card'>
            <ul className="timeline-list">
              {timelineItems.map((item, idx) => (
                <li key={idx} className="timeline-item">
                  <strong>{item.label}:</strong>{' '}
                  {Array.isArray(item.content) ? (
                    <ul className="timeline-sublist">
                      {item.content.map((sub, subIdx) => (
                        <li key={subIdx}>{sub}</li>
                      ))}
                    </ul>
                  ) : (
                    item.content
                  )}
                </li>
              ))}
            </ul>
          </div>           */}
      </div>
    </>
  );
};

export default Timeline;
